import { get, post } from "./http-instance";

export default class FeedbackService {
  static async saveFeedback(data) {
    return post("App/Feedback", data);
  }
}
